import type { GridFilterItem, GridFilterModel } from "@mui/x-data-grid";

type DeviceFilterInput = {
  serialNumber: string;
  modelName?: string | null;
};

export const getDeviceFilterModel = ({
  serialNumber,
  modelName,
}: DeviceFilterInput): GridFilterModel => {
  const items: GridFilterItem[] = [
    {
      id: "device-serial-number",
      field: "serialNumber",
      operator: "equals",
      value: serialNumber,
    },
  ];

  if (modelName) {
    items.push({
      id: "device-model-name",
      field: "modelName",
      operator: "equals",
      value: modelName,
    });
  }

  return { items };
};

export const getDeviceFilterSearch = (input: DeviceFilterInput): string =>
  `?${new URLSearchParams({ filters: JSON.stringify(getDeviceFilterModel(input)) }).toString()}`;

export const getSerialNumberFilterSearch = (serialNumber: string): string =>
  getDeviceFilterSearch({ serialNumber });
